// extracted by mini-css-extract-plugin
module.exports = {"noteTabs":"style-module__noteTabs___I2Wtg","note":"style-module__note___2dBpI","notes":"style-module__notes___3czOL","notesColumn":"style-module__notesColumn___299lX"};